const fillCondition = () => {
  return {
    isOnlineAgent: value => value?.includes && value.includes('conv'),
    isCallAgent: value => value?.includes && value.includes('call'),
    isOnlineAndCallAgent: value => value?.includes && value.includes('conv') && value.includes('call'),
  };
};

export default fillCondition;
